import type { Entry, EntryPatch } from './types'

class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly retryAfter?: number,
  ) {
    super(message)
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...init?.headers },
  })
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; retryAfter?: number }
    throw new ApiError(body.error ?? res.statusText, res.status, body.retryAfter)
  }
  return res.json() as Promise<T>
}

export { ApiError }

export const api = {
  session: () => request<{ authenticated: boolean }>('/api/session'),

  login: (password: string) =>
    request<{ ok: true }>('/api/login', {
      method: 'POST',
      body: JSON.stringify({ password }),
    }),

  logout: () => request<{ ok: true }>('/api/logout', { method: 'POST' }),

  entry: (date: string) => request<Entry | null>(`/api/entries/${date}`),

  entries: (from?: string, to?: string) => {
    const qs = from && to ? `?from=${from}&to=${to}` : ''
    return request<Entry[]>(`/api/entries${qs}`)
  },

  patch: (date: string, patch: EntryPatch) =>
    request<Entry>(`/api/entries/${date}`, { method: 'PUT', body: JSON.stringify(patch) }),
}
